// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"9b111f81","782":"296c03ca"}[chunkId] + ".chunk.js";
};